import { render } from "./btnCerrar.vue?vue&type=template&id=21ea4583"
import script from "./btnCerrar.vue?vue&type=script&lang=js"
export * from "./btnCerrar.vue?vue&type=script&lang=js"

import "./btnCerrar.vue?vue&type=style&index=0&id=21ea4583&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__